(function() {

    var domElement = document.getElementById('animation');

    if (!domElement) {
        return;
    }

    var PIXI = window.PIXI;
    var requestAnimationFrame = window.requestAnimationFrame;
    var cancelAnimationFrame = window.cancelAnimationFrame;

    window.addEventListener('orientationchange', delayedResize);
    window.addEventListener('resize', delayedResize);

    var resizeRequest

    function delayedResize () {
        if (resizeRequest) clearTimeout(resizeRequest);
        resizeRequest = setTimeout(resize, 500);
    }

    var width;
    var height;

    var sprinkleTextures = getTextures();

    var sprinkles = []
    // var gravity = 0.5

    var maxX, minX, maxY, minY;

    var startsprinkleCount = 0;
    var maxSprinkles = 2000;
    var addSprinkleCount = 0;
    var count = 0;
    var container;

    var offset = {
        x: 0,
        y: 0
    }

    var mousePos = {
        x: 0,
        y: 0
    }

    var renderer;
    var stage;

    var isWebGL;

    var animFrame;

    var overlay;

    function onReady () {
        getBounds();
        init();
        // resize()
    }

    function getBounds() {
        width = domElement.offsetWidth;
        height = domElement.offsetHeight;

        maxX = width + 20;
        minX = 0 - 20;
        maxY = height + 20;
        minY = 0 - 20;

        addSprinkleCount = Math.round(width/70);
        maxSprinkles = width*2;
    }

    function sizeOverlay() {
        if (!overlay) {
            return;
        }
        overlay.scale.set(width / 800, height / 600);
        overlay.position.x = 0;
        overlay.position.y = 0;
    };

    function getTextures() {
        if (sprinkleTextures && sprinkleTextures.length) {
            for (var i=0; i<sprinkleTextures.length; i++) {
                sprinkleTextures[i].destroy(true);
            }
        }
        return [
            new PIXI.Texture.fromImage('/anim/sprinkle1.png', undefined, undefined, 1.0),
            new PIXI.Texture.fromImage('/anim/sprinkle2.png', undefined, undefined, 1.0),
            new PIXI.Texture.fromImage('/anim/sprinkle3.png', undefined, undefined, 1.0)
        ]
    }

    function init () {
        renderer = PIXI.autoDetectRenderer(width, height, {
            //backgroundColor: 0x000000
            transparent: true
        });
        stage = new PIXI.Container(0xFFFFFF);

        isWebGL = renderer instanceof PIXI.WebGLRenderer;

        if (!isWebGL) {
            renderer.context.mozImageSmoothingEnabled = false;
            renderer.context.webkitImageSmoothingEnabled = false;
        }

        /*
        * Fix for iOS GPU issues
        */
        renderer.view.style['transform'] = 'translatez(0)'

        domElement.appendChild(renderer.view)
        renderer.view.style.position = 'absolute'

        var loader = new PIXI.loaders.Loader();
        loader.add('overlay', '/anim/overlay_rect2.png')
        loader.load(function(loader, resources) {
            // container = new PIXI.particles.ParticleContainer(maxSprinkles, [false, true, false, false, false])
            container = new PIXI.Container();
            stage.addChild(container);

            var logoContainer = new PIXI.Container();

            overlay = new PIXI.Sprite(new PIXI.Texture.fromImage('/anim/overlay_rect2.png', undefined, undefined, 1.0));
            sizeOverlay();
            //logoContainer.addChild(overlay);

            stage.addChild(logoContainer);

            for (var i = 0; i < startsprinkleCount; i++) {
                addsprinkle();
            }

            animFrame = requestAnimationFrame(update);
        });
    }

    function addsprinkle() {
        if (count >= maxSprinkles) {
            return;
        }
        var index = Math.floor(Math.random() * sprinkleTextures.length);
        var texture = sprinkleTextures[index];
        var sprinkle = new PIXI.Sprite(texture);
        sprinkle.position.x = Math.round(Math.random() * width);
        sprinkle.position.y = -20;
        sprinkle.speedX = (Math.random() - 0.5);
        sprinkle.speedY = (Math.random() - 0.5) * 4;

        if (Math.abs(sprinkle.speedX) + Math.abs(sprinkle.speedY) < 1) {
            // sprinkle.speedX += (sprinkle.speedX > 0 ? 1 : -1);
            sprinkle.speedY += (sprinkle.speedY > 0 ? 1 : -1);
        }

        sprinkle.anchor.y = 0.5
        sprinkle.anchor.x = 0.5
        sprinkle.scale.set((Math.random() * 0.25) + 0.4);
        sprinkle.alpha = 0.5 + (Math.random() * 0.5);
        sprinkles.push(sprinkle)
        sprinkle.rotation = (Math.random() - 0.5);
        sprinkle.rotationSpeed = (Math.random() * 0.025);
        sprinkle.zIndex = 0;
        container.addChild(sprinkle);
        count++;
    }

    function resize () {
        if (domElement.offsetWidth === width) {
            return;
        }
        cancelAnimationFrame(animFrame);
        getBounds();
        var canvas = renderer.view;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
        canvas.width = width;
        canvas.height = height;
        renderer.resize(width, height);
        // renderer.view.style.width = width + 'px';
        // renderer.view.style.height = height + 'px';
        sizeOverlay();

        // Re-create texture
        container.removeChildren(false);
        count = 0;
        sprinkles = [];

        animFrame = requestAnimationFrame(update);
    }

    function update () {
        var sprinkle;
        var i;

        var newsprinkles = [];

        for (i = 0; i < sprinkles.length; i++) {
            sprinkle = sprinkles[i]

            sprinkle.position.x += sprinkle.speedX
            sprinkle.position.y += sprinkle.speedY
            sprinkle.rotation += sprinkle.rotationSpeed;

            var keep = true;

            if (sprinkle.position.x > maxX) {
                keep = false;
            } else if (sprinkle.position.x < minX) {
                keep = false;
            }

            if (sprinkle.position.y > maxY) {
                keep = false
            } else if (sprinkle.position.y < minY) {
                keep = false;
            }

            if (keep) {
                newsprinkles.push(sprinkle);
            }
            else {
                container.removeChild(sprinkle);
                count--;
            }
        }

        sprinkles = newsprinkles;

        for (var i=0; i<addSprinkleCount; i++) {
            addsprinkle();
        }

        renderer.render(stage)
        animFrame = requestAnimationFrame(update)
    }
    window.addEventListener('DOMContentLoaded', function () {
        onReady();
    });
})();